export default {
    versions: {
        title: 'Theme versions',
        intro: "Deploy a tag from {code}'s git repo. Worker downloads, validates, and compiles the tarball.",
        tag: 'Tag',
        deploy: 'Deploy',
        clear: 'Clear',
        removeCount: 'Remove {n}',
        empty: 'No deployments yet.',
        selectAll: 'Select all removable versions',
        version: 'Version',
        branch: 'branch',
        remote: 'remote',
        confirmRemove: 'Remove?',
        activate: 'Activate',
        skip: 'Skip: hide this tag without deploying',
        removeVersion: 'Remove version',
        bulkFailed: 'Some versions could not be removed: {failures}',
    },
    status: {
        queued: 'queued',
        success: 'success',
        failed: 'failed',
        available: 'available',
    },
};
